document.addEventListener("DOMContentLoaded", function () {
  let splideEl = document.getElementById("splide__brand_slide");
  if (splideEl) {
    let splide = new Splide(splideEl, {
      type: "loop",
      perPage: 6,
      pagination: false,
      arrows: false,
      autoplay: true,
      gap: "1rem",
      breakpoints: {
        1024: { perPage: 4 },
        768: { perPage: 3 },
        480: { perPage: 2 },
      },
    });
    splide.mount();
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   var splide = new Splide('#splide__review_slide', {
//     perPage: 3,
//     gap: '20px',
//     pagination: false,
//     arrows: true,
//     breakpoints: {
//       768: { perPage: 1 }
//     }
//   });

//   var bar = splide.root.querySelector('.my-slider-progress-bar');

//   splide.on('mounted move', function () {
//     var end  = splide.Components.Controller.getEnd() + 1;
//     var rate = Math.min((splide.index + 1) / end, 1);
//     bar.style.width = String(100 * rate) + '%';
//   });

//   splide.mount();
// });

document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('#splide__review_slide', {
    perPage: 2,
    gap: '20px',
    pagination: false,
    arrows: false, 
    padding: { right: '15%' }, // show 0.3 of next slide
    breakpoints: {
      768: { perPage: 1, padding: { right: '0' } }
    }
  });

  var bar = splide.root.querySelector('.my-slider-progress-bar');

  splide.on('mounted move', function () {
    var end  = splide.Components.Controller.getEnd() + 1;
    var rate = Math.min((splide.index + 1) / end, 1);
    bar.style.width = String(100 * rate) + '%';
  });
  document.querySelector('.custom-arrow-prev').addEventListener('click', function () {
    splide.go('<');
  });
  document.querySelector('.custom-arrow-next').addEventListener('click', function () {
    splide.go('>');
  });

  splide.mount();
});

document.addEventListener("DOMContentLoaded", function () {
  let splideText = document.getElementById("splide__text_slide");
  if (splideText) {
    let splide = new Splide(splideText, {
      type: "loop",
      perPage: 1,
      pagination: false,
      arrows: false,
      autoplay: true,
      gap: "1rem",
      breakpoints: {
        1024: { perPage: 1 },
        768: { perPage: 1 },
        480: { perPage: 2 },
      },
    });
    document.querySelector('.custom-arrow-prev-2').addEventListener('click', function () {
    splide.go('<');
  });
  document.querySelector('.custom-arrow-next-2').addEventListener('click', function () {
    splide.go('>');
  });
    splide.mount();
  }
});


